module.exports = __webpack_public_path__ + "static/media/bottle-mobile.d8637cbb.png";